<ng-template #device let-entry="entry" let-group="group">
  @if (group | notBlank) {
    <strong>{{ group | translate }}</strong>
  }

  @if (isDevice(entry); as device) {
    <span>{{ device.meta.device.name }}</span>
  } @else {
    <span>{{ entry.label | translate }}</span>
  }
</ng-template>

<ng-template #user let-entry="entry" let-group="group">
  @if (group | notBlank) {
    <strong>{{ group | translate }}</strong>
  }

  @if (isUser(entry); as user) {
    <span>{{ user.meta.user | contactName: { type: 'with-extension' } }}</span>
  } @else {
    <span>{{ entry.label | translate }}</span>
  }
</ng-template>
